export default __webpack_public_path__ + "static/media/permit_example.a037320f.png";